import {
  companyProfile,
  aboutPage as legacyAboutPage,
  contactPage as legacyContactPage
} from '../siteContent'

export { companyProfile, legacyAboutPage, legacyContactPage }

export const zhPreview = {
  theme: 'data',
  eyebrow: '平台总览',
  title: '乐康平台能力总览',
  subtitle: '将采集、治理、分析与协作集中在统一平台',
  status: '持续运营',
  pill: '可信协同',
  metrics: [
    { label: '接入系统', value: '16' },
    { label: '协同任务', value: '83' },
    { label: '安全策略', value: '27' }
  ],
  panels: [
    {
      title: '平台模块',
      items: ['临床数据采集', '研究工作台', '数据分析中心']
    },
    {
      title: '运营进度',
      bars: [
        { label: '业务接入', value: '88%', ratio: 88 },
        { label: '数据治理', value: '76%', ratio: 76 },
        { label: '安全审计', value: '93%', ratio: 93 }
      ]
    },
    {
      title: '能力关键词',
      tags: ['标准建模', '质量控制', '权限审计', '数据分析']
    }
  ],
  footer: ['统一入口', '流程协同', '数据沉淀']
}

export const enPreview = {
  theme: 'data',
  eyebrow: 'Overview',
  title: 'Alekang Capability Overview',
  subtitle:
    'Data capture, governance, analytics and collaboration in one platform',
  status: 'In operation',
  pill: 'Trusted data',
  metrics: [
    { label: 'Systems', value: '16' },
    { label: 'Tasks', value: '83' },
    { label: 'Policies', value: '27' }
  ],
  panels: [
    {
      title: 'Modules',
      items: ['Clinical data capture', 'Research workspace', 'Analytics center']
    },
    {
      title: 'Progress',
      bars: [
        { label: 'Adoption', value: '88%', ratio: 88 },
        { label: 'Governance', value: '76%', ratio: 76 },
        { label: 'Audit', value: '93%', ratio: 93 }
      ]
    },
    {
      title: 'Capabilities',
      tags: ['Standard model', 'Quality control', 'Access audit', 'Analytics']
    }
  ],
  footer: ['Unified access', 'Workflow', 'Data assets']
}

export const quickLinksZh = [
  { name: '管理平台', href: 'https://admin.alekang.com' },
  { name: '研究平台', href: 'https://research.alekang.com' },
  { name: '数据中心', href: 'https://data.alekang.com' },
  { name: '文档中心', href: 'https://doc.alekang.com' },
  { name: '邮箱系统', href: 'https://mail.alekang.com' }
]

export const quickLinksEn = [
  { name: 'Admin Platform', href: 'https://admin.alekang.com' },
  { name: 'Research Platform', href: 'https://research.alekang.com' },
  { name: 'Data Center', href: 'https://data.alekang.com' },
  { name: 'Documentation', href: 'https://doc.alekang.com' },
  { name: 'Mail System', href: 'https://mail.alekang.com' }
]

export const baseCompanyZh = {
  ...companyProfile,
  description:
    '专注临床研究与医疗数据协同平台建设，提供数据采集、研究管理、报表分析与可信治理服务。',
  mission: '规范采集、可信治理、安全协同',
  slogan: '让医疗数据更清晰、更可信、更易协作'
}

export const baseCompanyEn = {
  ...companyProfile,
  name: 'Alekang Digital Technology',
  shortName: 'Alekang',
  description:
    'Alekang builds collaboration platforms for clinical research and medical data, covering data capture, research operations, analytics and trusted governance.',
  mission: 'Reliable capture, trusted governance, secure collaboration',
  slogan: 'Clearer medical data, safer collaboration',
  publicAccountLabel: 'WeChat',
  address:
    '16F, Building A, Anke Building, No. 31 Guangju Road, Jianye District, Nanjing, Jiangsu, China',
  recordNumber: companyProfile.recordNumber
}
